import { Component, ContentChildren, EventEmitter, Input, OnInit, Output, QueryList } from '@angular/core'
import { TabComponent } from './tab/tab.component'
import { of, Subject, Observable } from 'rxjs';
@Component({
	selector: 'atyl-tab-group',
	templateUrl: './tab-group.component.html',
	styleUrls: ['./tab-group.component.scss']
})
export class TabGroupComponent implements OnInit {

	constructor(
	) { }

	@Input() clickTab: Observable<any>;

	@Input() tabDirection: string = 'vertical';
	@ContentChildren(TabComponent) tabs: QueryList<TabComponent>
	@Output() selectedTabChange: EventEmitter<any> = new EventEmitter;
	@Input() dialog: boolean = false;
	@Input() columns: string = '2';
	@Input() reduced: boolean = false

	ngOnInit() {
		if (this.clickTab!=undefined)
			this.clickTab.subscribe((tab) => {
				console.log("TabGroupComponent click",tab);
				this.selectTabCode(tab)
			})
	}

	ngAfterContentInit(): void {
		// Trouve toutes les tabs activées
		let activeTabs = this.tabs.filter((tab) => tab.active)
		// console.log(this.tabs);
		// S'il n'y a pas de tab activée, active la première
		if (activeTabs.length === 0) {
			this.tabs.first && this.selectTab(this.tabs.first)
		}
	}

	selectTab(tab: any) {
		console.log(tab)
		// Désactive toutes les tabs
		this.tabs.toArray().forEach(tab => tab.active = false)

		// Active la tab cliquée
		tab.active = true
		this.selectedTabChange.emit(tab)
	}

	onClickTab(tb: any) {
		this.tabs.toArray().forEach((tab, index) => {
			tab.active = false
			if (tb.index != undefined && tb.index == index) {
                console.log("TabGroupComponent clicked2", tb, index)
				tab.active = true
				this.selectedTabChange.emit(tab)
			}
		})
	}

	selectTabCode(tb: any) {
		this.tabs.toArray().forEach((tab, index) => {
			tab.active = false
			if (tb.code != undefined && tb.code == tab.code) {
                console.log("TabGroupComponent clicked", tb, tab)
				tab.active = true
				this.selectedTabChange.emit(tab)
			}
		})
	}

	toggleReduce() {
		this.reduced = !this.reduced
	}
}
